import { Stack, Typography } from "@mui/material";
import { useShow } from "@refinedev/core";
import { Show, TextFieldComponent as TextField } from "@refinedev/mui";
import { gemsOf } from "./values";

const formatDateTime = (value?: string | null) => {
  if (!value) {
    return "-";
  }

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return value;
  }

  return date.toLocaleString();
};

export const CreditBundleShow = () => {
  const { query } = useShow({});
  const { data, isLoading } = query;

  const record = data?.data;

  return (
    <Show isLoading={isLoading} title="Credits Pack">
      <Stack gap={1}>
        <Typography variant="body1" fontWeight="bold">
          {"ID"}
        </Typography>
        <TextField value={record?.id} />

        <Typography variant="body1" fontWeight="bold">
          {"Key"}
        </Typography>
        <TextField value={record?.key} />

        <Typography variant="body1" fontWeight="bold">
          {"Name"}
        </Typography>
        <TextField value={record?.name} />

        <Typography variant="body1" fontWeight="bold">
          {"Gems"}
        </Typography>
        <TextField value={record?.creditsAmount} />

        <Typography variant="body1" fontWeight="bold">
          {"Bonus Gems"}
        </Typography>
        <TextField value={record?.bonusCredits} />

        <Typography variant="body1" fontWeight="bold">
          {"Gems Sold"}
        </Typography>
        <TextField value={record ? gemsOf(record.creditsAmount, record.bonusCredits).gems : undefined} />

        <Typography variant="body1" fontWeight="bold">
          {"Price (USD)"}
        </Typography>
        <TextField value={record?.priceUsd} />

        <Typography variant="body1" fontWeight="bold">
          {"Best Value"}
        </Typography>
        <TextField value={record?.isBest ? "Yes" : "No"} />

        <Typography variant="body1" fontWeight="bold">
          {"App Store Product ID"}
        </Typography>
        <TextField value={record?.appleProductId || "-"} />

        <Typography variant="body1" fontWeight="bold">
          {"Google Play Product ID"}
        </Typography>
        <TextField value={record?.googleProductId || "-"} />

        <Typography variant="body1" fontWeight="bold">
          {"On Sale"}
        </Typography>
        <TextField value={record?.isActive ? "Yes" : "No"} />

        <Typography variant="body1" fontWeight="bold">
          {"Sort Order"}
        </Typography>
        <TextField value={record?.sortOrder} />

        <Typography variant="body1" fontWeight="bold">
          {"Created At"}
        </Typography>
        <TextField value={formatDateTime(record?.createdAt)} />

        <Typography variant="body1" fontWeight="bold">
          {"Updated At"}
        </Typography>
        <TextField value={formatDateTime(record?.updatedAt)} />
      </Stack>
    </Show>
  );
};

